import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { getCSRF } from 'helpers/shared';
import Link from '@fountain/ui-kit/components/link';

export default class UjsLink extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    href: PropTypes.string.isRequired,
    method: PropTypes.string.isRequired,
    target: PropTypes.string,
  }

  static defaultProps = {
    children: null,
    target: '_self',
  }

  _onClick = (e) => {
    const { href, method, target } = this.props;

    if (!method) {
      return;
    }

    e.preventDefault();

    const csrf = getCSRF();
    const form = document.createElement('form');
    const methodInput = document.createElement('input');

    form.method = 'post';
    form.action = href;
    form.target = target;
    form.style.display = 'none';

    methodInput.type = 'hidden';
    methodInput.name = '_method';
    methodInput.value = method;
    form.appendChild(methodInput);

    if (csrf) {
      const csrfTokenInput = document.createElement('input');

      csrfTokenInput.type = 'hidden';
      csrfTokenInput.name = csrf.param;
      csrfTokenInput.value = csrf.token;
      form.appendChild(csrfTokenInput);
    }

    document.body.appendChild(form);
    form.submit();
  }

  render() {
    const { children, ...restProps } = this.props;

    return <Link {...restProps} onClick={this._onClick}>{children}</Link>;
  }
}
